// extracted by mini-css-extract-plugin
export default {"btnGroup":"ButtonGroup--btnGroup--YyP2d"};